<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';
import ProviderManagementList from '@/components/page-provider-management/ProviderManagementList.vue';
import { promiseAll, calculatePromise } from '@/api/default.js';

export default {
    name: 'ProviderManagementPage',

    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        ProviderManagementList,
    },

    computed: {
        statusFilters() {
            return this.$store.getters.ADMIN_PUBLISHERS_FILTERS;
        },
    },

    async mounted() {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                '[ProviderManagementPage.mounted] Initialising page'
            );
        }

        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            {
                dispatch: 'loadAdminPublishers',
                commit: null,
                isArray: false,
            },
        ]);
        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);

        if (process.env.NODE_ENV !== 'production') {
            console.info(
                '[ProviderManagementPage.mounted] Page ready'
            );
        }
    },

    methods: {
        async setStatusFilter(status) {
            if (process.env.NODE_ENV !== 'production') {
                console.info(
                    '[ProviderManagementPage.setStatusFilter] →',
                    status
                );
            }
            this.$store.commit('SET_ADMIN_PUBLISHERS_FILTERS', { status });
            this.$store.commit('SET_ADMIN_PUBLISHERS_PAGE', 1);
            await this.$store.dispatch('loadAdminPublishers');
        },
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
            <hr class="left-separator" />

            <label class="chapter_header">Filter by Status</label>

            <button
                @click="setStatusFilter(null)"
                :class="{ active: !statusFilters.status }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">All Providers</label>
            </button>

            <button
                @click="setStatusFilter('active')"
                :class="{ active: statusFilters.status === 'active' }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Active</label>
            </button>

            <button
                @click="setStatusFilter('deleted')"
                :class="{ active: statusFilters.status === 'deleted' }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Deleted</label>
            </button>

            <button
                @click="setStatusFilter('migrated')"
                :class="{ active: statusFilters.status === 'migrated' }"
                class="left_button_main_container"
            >
                <label class="cursor_pointer">Migrated</label>
            </button>
        </LeftPanel>

        <RightContainer>
            <div class="right_container_block">
                <div class="right_header">
                    <label>Provider Management</label>
                </div>
                <hr class="section_hr" />
                <ProviderManagementList />
            </div>
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.right_container_block {
    padding: 20px;
}

.right_header {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
}

.section_hr {
    margin: 0 0 20px;
    border: none;
    border-top: 1px solid var(--border-color);
}

/* Active left panel button */
.left_button_main_container.active {
    background-color: var(--main-color);
    color: white;
}
</style>
